import React from "react";
import NHeader from "../NHeader";
import NavigatorMain from "../NavigatorMain";
import Util, { ToastTime } from "../../util";
import PositionList from "../PositionList";
import { hashHistory } from "react-router";
import "./targetProfitHaveCast.css";
import { Toast } from "antd-mobile/lib";
class PositionDetails extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    document.title = "持仓明细";
  }
  toPublicOffering = (item) => {
    if (item.camcOrNonCamcWhiteListFundFlag === "0") return Toast.info("该产品暂不支持交易", ToastTime);
    hashHistory.push({ pathname: "/PublicOffering", query: { fundCode: item.fundCode }, state: { fundCode: item.fundCode } });
  };
  renderItem = (item) => {
    const currentNavDate = new Date(item.currentNavDateDesc);

    return (
      <div key={item.fundCode} className="PDH_item" style={{ padding: "0 .3rem" }} >
        <div style={{ padding: ".3rem 0" }}>
          <div className="style_flex_row_between style_sm_font style_font_weight" style={{ marginBottom: ".3rem" }}>
            <span>
              {item.fundName}-{item.fundCode}
            </span>
            <span style={{ color: "#B69271" }}>占比: {Util.toPercent(item.rate)}</span>
          </div>
          <div className="style_flex_row_between style_sm_font">
            <div className="style_flex_average style_left_align">
              <div className="style_color_neutral" style={{ marginBottom: ".06rem" }}>
                持有金额
              </div>
              <div className="style_font_weight">{item.amount.toFixed(2)}</div>
            </div>
            <div className="style_flex_average style_center_align">
              <div className="style_color_neutral" style={{ marginBottom: ".06rem" }}>
                可用份额
              </div>
              <div className="style_font_weight">{item.realBalance.toFixed(2)}</div>
            </div>
            <div className="style_flex_average style_right_align">
              <div className="style_color_neutral" style={{ marginBottom: ".06rem" }}>
                {currentNavDate.getMonth() + 1}.{currentNavDate.getDate()}净值
              </div>
              <div className="style_font_weight">{item.currentNav.toFixed(4)}</div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  header = (v) => (
    <div className="style_flex_row_between" style={{ padding: ".1rem .3rem", background: Util.pieEchartsFundListColorMap.get(v.styleTypeName) }}>
      <span className="style_md_white_font style_font_weight" style={{ color: "#3C3C3C" }}>
        {v.styleTypeName}
      </span>
      <span className="style_sm_font style_color_light">共占比{Util.toPercent(v.totalRate)}</span>
    </div>
  );
  render() {
    const { fundItems = [] } = this.props.location.state;
    console.log("this.props.location", this.props.location);
    return (
      <div className="PD_container" style={{ minHeight: window.winHeight, background: `#fff url(${require("../../img/n_icon_header_bg@2x.png")}) no-repeat 0 0/100% auto` }}>
        <NavigatorMain>
          <NHeader title="持仓明细" />
        </NavigatorMain>

        <div className="PD_list">
          {fundItems.map((v, i) => (
            <PositionList key={i} background={Util.pieEchartsFundListBgColorMap.get(v.styleTypeName)} header={this.header(v)} renderItem={this.renderItem} dataSource={v.superFundItemShareList} />
          ))}
        </div>
      </div>
    );
  }
}

export default PositionDetails;



// WEBPACK FOOTER //
// ./src/components/fundDetail/PositionDetailsHaveCast.js